import { OwnerResponsibility } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

/** The picker is entity-agnostic and carries plain strings; the API wants the enum. */
export const toResponsibility = (value: string | null): OwnerResponsibility | null =>
  Object.values(OwnerResponsibility).find((responsibility) => responsibility === value) ?? null

export const responsibilityLabel = (responsibility: OwnerResponsibility): string =>
  ({
    [OwnerResponsibility.PrimaryContact]: $t('Primary contact'),
    [OwnerResponsibility.Compliance]: $t('Compliance'),
    [OwnerResponsibility.Payments]: $t('Payments'),
    [OwnerResponsibility.Recruitment]: $t('Recruitment'),
  })[responsibility]
